// extracted by mini-css-extract-plugin
export var dividerLine = "_83-3";
export var itemImage = "_83-9";
export var lightDivider = "_83-4";
export var modalContent = "_83-5";
export var modalContentCompact = "_83-6";
export var productCard = "_83-a";
export var productImage = "_83-b";
export var productImageCompact = "_83-7";
export var productImagePlaceholder = "_83-c";
export var productImagePlaceholderCompact = "_83-8";
export var progressBarBackground = "_83-1";
export var progressBarContainer = "_83-0";
export var progressBarFill = "_83-2";